(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sp-announcement"] && !Shopify.designMode) return;
  try {
    
  // Rotates the announcement messages one at a time; pauses on hover/focus and
  // stays on the first message when the visitor prefers reduced motion.
  document.querySelectorAll('[data-sp-announce-rotate]').forEach((bar) => {
    if (bar.dataset.spReady) return;
    bar.dataset.spReady = '1';
    const items = bar.querySelectorAll('[data-sp-announce-msg]');
    if (items.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const every = Math.max(3, Number(bar.dataset.spAnnounceRotate) || 5) * 1000;
    let index = 0;
    let timer = null;
    const show = (i) => { items.forEach((el, n) => { el.classList.toggle('is-current', n === i); el.setAttribute('aria-hidden', n === i ? 'false' : 'true'); }); };
    const start = () => { if (!timer) timer = setInterval(() => { index = (index + 1) % items.length; show(index); }, every); };
    const stop = () => { clearInterval(timer); timer = null; };
    bar.addEventListener('mouseenter', stop);
    bar.addEventListener('mouseleave', start);
    bar.addEventListener('focusin', stop);
    bar.addEventListener('focusout', start);
    document.addEventListener('visibilitychange', () => (document.hidden ? stop() : start()));
    start();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sp-article"]) return;
  try {
    
  (function () {
    const root = document.querySelector('[data-sp-article]');
    if (!root || root.dataset.spReady) return;
    root.dataset.spReady = '1';

    // Contents: open in the sidebar (desktop), collapsed on phones.
    const toc = root.querySelector('[data-sp-toc]');
    const wide = window.matchMedia('(min-width: 1024px)');
    if (toc) {
      const summary = toc.querySelector('summary');
      const sync = () => {
        if (wide.matches) toc.open = true;
        // the summary is only a toggle on phones; keep it out of the desktop tab order
        if (summary) summary.tabIndex = wide.matches ? -1 : 0;
      };
      sync();
      wide.addEventListener('change', sync);
    }

    // Highlight the current section in the contents list.
    const headings = root.querySelectorAll('[data-sp-heading]');
    const tocLinks = root.querySelectorAll('[data-sp-toc] .sp-toc__link');
    if (headings.length && tocLinks.length && 'IntersectionObserver' in window) {
      const byId = {};
      tocLinks.forEach((a) => { byId[a.getAttribute('href').slice(1)] = a.closest('.sp-toc__item'); });
      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((e) => {
            if (!e.isIntersecting) return;
            tocLinks.forEach((a) => a.closest('.sp-toc__item').classList.remove('is-current'));
            const item = byId[e.target.id];
            if (item) item.classList.add('is-current');
          });
        },
        { rootMargin: '-20% 0px -70% 0px', threshold: 0 }
      );
      headings.forEach((h) => io.observe(h));
    }

    // Share: native sheet where available, otherwise copy the link.
    const share = root.querySelector('[data-sp-share]');
    if (share) {
      share.addEventListener('click', async () => {
        const url = share.dataset.spShareUrl;
        const title = share.dataset.spShareTitle;
        if (navigator.share) {
          try { await navigator.share({ title, url }); } catch (e) {}
          return;
        }
        try {
          await navigator.clipboard.writeText(url);
          const label = share.querySelector('[data-sp-share-label]');
          const original = label.textContent;
          label.textContent = share.dataset.spShareCopied;
          setTimeout(() => { label.textContent = original; }, 2000);
        } catch (e) {}
      });
    }

    // Phone bottom bar: appears once the reader passes the intro, hides at the
    // end of the body (closing card or author box), stays dismissed for the session.
    const bar = root.querySelector('[data-sp-article-bar]');
    const sentinel = root.querySelector('[data-sp-article-sentinel]');
    const end = root.querySelector('[data-sp-article-closing]') || root.querySelector('[data-sp-article-end]');
    if (!bar || !sentinel) return;
    const key = 'sp-article-bar-dismissed';
    let dismissed = false;
    try { dismissed = sessionStorage.getItem(key) === '1'; } catch (e) {}
    let nearEnd = false;
    let ticking = false;
    const update = () => {
      ticking = false;
      if (dismissed || nearEnd) { bar.hidden = true; return; }
      bar.hidden = sentinel.getBoundingClientRect().top > 0;
    };
    const onScroll = () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    if (end && 'IntersectionObserver' in window) {
      new IntersectionObserver((entries) => { nearEnd = entries[0].isIntersecting || entries[0].boundingClientRect.top < 0; update(); }, { threshold: 0 }).observe(end);
    }
    const close = bar.querySelector('[data-sp-article-bar-close]');
    if (close) close.addEventListener('click', () => { dismissed = true; try { sessionStorage.setItem(key, '1'); } catch (e) {} update(); });
    update();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sp-bf-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sp-bf-countdown')) {
    customElements.define(
      'sp-bf-countdown',
      class SpBfCountdown extends HTMLElement {
        connectedCallback() {
          if (this.dataset.spReady) return;
          this.dataset.spReady = '1';
          this.end = Date.parse(this.dataset.spEnd);
          if (Number.isNaN(this.end)) return;
          this.units = {};
          this.querySelectorAll('[data-sp-unit]').forEach((el) => {
            this.units[el.dataset.spUnit] = el;
          });
          this.tick();
          this.timer = setInterval(() => this.tick(), 1000);
        }

        disconnectedCallback() {
          clearInterval(this.timer);
        }

        tick() {
          const left = Math.max(0, this.end - Date.now());
          if (left === 0) {
            this.hidden = true;
            clearInterval(this.timer);
            return;
          }
          const pad = (n) => String(n).padStart(2, '0');
          const s = Math.floor(left / 1000);
          this.units.d.textContent = pad(Math.floor(s / 86400));
          this.units.h.textContent = pad(Math.floor((s % 86400) / 3600));
          this.units.m.textContent = pad(Math.floor((s % 3600) / 60));
          this.units.s.textContent = pad(s % 60);
          this.hidden = false;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sp-bf-offer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sp-bf-offer')) {
    customElements.define(
      'sp-bf-offer',
      class SpBfOffer extends HTMLElement {
        connectedCallback() {
          if (this.dataset.spReady) return;
          this.dataset.spReady = '1';
          const raw = this.querySelector('[data-sp-bf-data]');
          if (!raw) return;
          this.data = JSON.parse(raw.textContent);
          this.fmt = new Intl.NumberFormat(undefined, { style: 'currency', currency: this.data.currency });
          this.busy = false;
          this.touched = false;

          this.onChange = (e) => {
            if (e.target.matches('[data-sp-kit], [data-sp-row-opt]')) {
              this.touched = true;
              this.update();
            }
          };
          this.onClick = (e) => {
            const unlock = e.target.closest('[data-sp-gift-unlock]');
            if (unlock) {
              this.unlock(Number(unlock.dataset.spGiftUnlock), unlock.closest('[data-sp-gift-tier]'));
              return;
            }
            const btn = e.target.closest('[data-sp-bf-add]');
            if (!btn) return;
            if (btn.hasAttribute('data-sp-sticky-add') && !this.touched) {
              this.querySelector('.sp-bfoffer__box').scrollIntoView({ behavior: 'smooth', block: 'start' });
              return;
            }
            this.add(btn);
          };
          this.addEventListener('change', this.onChange);
          this.addEventListener('click', this.onClick);

          const main = this.querySelector('[data-sp-main-add]');
          const sticky = this.querySelector('[data-sp-sticky]');
          if (main && sticky && 'IntersectionObserver' in window) {
            this.observer = new IntersectionObserver(([entry]) => {
              sticky.hidden = entry.isIntersecting;
            });
            this.observer.observe(main);
          }
          this.update();
        }

        disconnectedCallback() {
          this.removeEventListener('change', this.onChange);
          this.removeEventListener('click', this.onClick);
          this.observer?.disconnect();
        }

        kit() {
          const checked = this.querySelector('[data-sp-kit]:checked');
          return checked ? Number(checked.value) : 1;
        }

        kitNameFor(tier) {
          return this.querySelector(`[data-sp-kit="${tier}"]`)?.dataset.spKitName || '';
        }

        unlock(tier, tile) {
          if (tier <= this.kit()) return;
          const radio = this.querySelector(`[data-sp-kit="${tier}"]`);
          if (!radio) return;
          const reveal = () => {
            radio.checked = true;
            this.touched = true;
            this.update();
            this.querySelectorAll('[data-sp-gift-tier]').forEach((t) => {
              const n = Number(t.dataset.spGiftTier);
              if (n > 1 && n <= tier && t.classList.contains('is-on') && !t.dataset.spRevealed) {
                t.dataset.spRevealed = '1';
                this.burst(t);
              }
            });
          };
          if (tile && !tile.classList.contains('is-on') && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            tile.classList.add('is-shake');
            setTimeout(() => {
              tile.classList.remove('is-shake');
              reveal();
            }, 380);
          } else {
            reveal();
          }
        }

        burst(tile) {
          const box = tile.querySelector('.sp-bfoffer__gift-burst');
          if (box) {
            box.innerHTML = '';
            for (let i = 0; i < 10; i++) {
              const dot = document.createElement('i');
              const a = (Math.PI * 2 * i) / 10;
              dot.style.setProperty('--x', `${Math.round(Math.cos(a) * 46)}px`);
              dot.style.setProperty('--y', `${Math.round(Math.sin(a) * 46)}px`);
              box.appendChild(dot);
            }
          }
          tile.classList.add('is-pop');
          setTimeout(() => {
            tile.classList.remove('is-pop');
            if (box) box.innerHTML = '';
          }, 800);
        }

        kitName() {
          return this.querySelector('[data-sp-kit]:checked')?.dataset.spKitName || '';
        }

        variantFor(row) {
          const optCount = this.data.variants[0].options.length;
          const picked = [];
          for (let o = 0; o < optCount; o++) {
            const input = this.querySelector(`[data-sp-row-opt="${row}-${o}"]:checked`);
            picked.push(input ? input.value : null);
          }
          return this.data.variants.find((v) => v.options.every((val, i) => val === picked[i])) || null;
        }

        money(cents) {
          return this.fmt.format(cents / 100);
        }

        update() {
          const n = this.kit();
          this.querySelectorAll('[data-sp-row]').forEach((row) => {
            row.hidden = Number(row.dataset.spRow) > n;
          });

          // every kit is priced from its own rows (hidden rows keep their picks), so switching kits never changes a number
          const rows = [1, 2, 3].map((r) => this.variantFor(r));
          const picks = rows.slice(0, n);
          const giftC = this.data.gift ? this.data.gift.compare * this.data.giftQty : 0;
          const bonusC = this.data.bonus ? this.data.bonus.compare : 0;
          const totals = {};
          for (let k = 1; k <= 3; k++) {
            const list = rows.slice(0, k);
            if (list.some((v) => !v)) continue;
            const price = list.reduce((s, v) => s + v.price, 0);
            let compare = list.reduce((s, v) => s + v.compare, 0);
            if (k >= 2) compare += giftC;
            if (k >= 3) compare += bonusC;
            totals[k] = { price, compare };
            const p = this.querySelector(`[data-sp-kit-price="${k}"]`);
            const c = this.querySelector(`[data-sp-kit-compare="${k}"]`);
            const s = this.querySelector(`[data-sp-kit-save="${k}"]`);
            if (p) p.textContent = this.money(price);
            if (c) c.textContent = this.money(compare);
            if (s) s.textContent = this.dataset.spSaveLabel.replace('[percent]', Math.round(((compare - price) * 100) / compare));
          }

          // colour names next to each row, and sold-out state per choice
          for (let r = 1; r <= 3; r++) {
            const label = this.querySelector(`[data-sp-row-color="${r}"]`);
            const v = this.variantFor(r);
            if (label) label.textContent = v ? v.options[this.data.colorIndex] : '';
          }

          this.querySelectorAll('[data-sp-gift-tier]').forEach((tile) => {
            const tier = Number(tile.dataset.spGiftTier);
            const on = tier <= n;
            tile.classList.toggle('is-on', on);
            if (!on) delete tile.dataset.spRevealed;
            tile.querySelectorAll('[data-sp-when-on]').forEach((el) => (el.hidden = !on));
            tile.querySelectorAll('[data-sp-when-off]').forEach((el) => (el.hidden = on));
            const lock = tile.querySelector('[data-sp-tap-label]');
            if (lock) lock.textContent = this.dataset.spTapLabel.replace('[kit]', this.kitNameFor(tier));
            const btn = tile.querySelector('[data-sp-gift-unlock]');
            if (btn) btn.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
          const unbox = this.querySelector('[data-sp-unbox]');
          const unboxText = this.querySelector('[data-sp-unbox-text]');
          if (unbox && unboxText) {
            const top = this.querySelectorAll('[data-sp-gift-tier]').length;
            if (n >= top) {
              unboxText.textContent = this.dataset.spAllLabel.replace('[count]', top);
              unbox.querySelector('button').disabled = true;
            } else {
              unboxText.innerHTML = this.dataset.spUnboxLabel.replace('[count]', top).replace('[kit]', `<strong>${this.kitNameFor(top)}</strong>`);
              unbox.querySelector('button').disabled = false;
            }
            unbox.hidden = false;
          }
          const progress = this.querySelector('[data-sp-progress]');
          if (progress) progress.textContent = this.dataset.spUnlockedLabel.replace('[unlocked]', n);

          const allAvailable = picks.every((v) => v && v.available);
          const total = totals[n] ? this.money(totals[n].price) : '';
          const addText = this.querySelector('[data-sp-add-text]');
          const main = this.querySelector('[data-sp-main-add]');
          if (addText) {
            addText.textContent = allAvailable
              ? this.dataset.spAddLabel.replace('[kit]', this.kitName()).replace('[price]', total)
              : this.dataset.spSoldoutLabel;
          }
          if (main) main.disabled = !allAvailable;
          const stickyName = this.querySelector('[data-sp-sticky-name]');
          const stickyPrice = this.querySelector('[data-sp-sticky-price]');
          if (stickyName) stickyName.textContent = this.kitName();
          if (stickyPrice) stickyPrice.textContent = total;
        }

        items() {
          const n = this.kit();
          const byId = new Map();
          for (let r = 1; r <= n; r++) {
            const v = this.variantFor(r);
            if (!v) return null;
            byId.set(v.id, (byId.get(v.id) || 0) + 1);
          }
          const items = [...byId].map(([id, quantity]) => ({ id, quantity }));
          if (n >= 2 && this.data.gift && this.data.gift.available) items.push({ id: this.data.gift.id, quantity: this.data.giftQty });
          if (n >= 3 && this.data.bonus && this.data.bonus.available) items.push({ id: this.data.bonus.id, quantity: 1 });
          return items;
        }

        setBusy(on) {
          this.busy = on;
          this.querySelectorAll('[data-sp-bf-add]').forEach((b) => {
            b.setAttribute('aria-busy', on ? 'true' : 'false');
          });
          const addText = this.querySelector('[data-sp-add-text]');
          if (on && addText) addText.textContent = this.dataset.spAddingLabel;
          if (!on) this.update();
        }

        async add() {
          if (this.busy) return;
          const items = this.items();
          const error = this.querySelector('[data-sp-error]');
          if (!items) return;
          error.hidden = true;
          this.setBusy(true);
          const drawer = document.querySelector('cart-drawer');
          const body = { items };
          if (drawer && typeof drawer.getSectionsToRender === 'function') {
            body.sections = drawer.getSectionsToRender().map((s) => s.id);
            body.sections_url = window.location.pathname;
            drawer.setActiveElement?.(document.activeElement);
          }
          const failsafe = setTimeout(() => this.setBusy(false), 15000);
          try {
            const res = await fetch(`${window.routes?.cart_add_url || '/cart/add'}.js`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
              body: JSON.stringify(body),
            });
            const data = await res.json();
            if (!res.ok || data.status) throw new Error(data.description || data.message || 'add failed');
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'sp-bf-offer', cartData: data });
            }
            if (drawer && data.sections) {
              drawer.classList.remove('is-empty');
              drawer.renderContents(data);
            } else {
              window.location.href = window.routes?.cart_url || '/cart';
            }
          } catch (e) {
            error.textContent = this.dataset.spErrorLabel;
            error.hidden = false;
          } finally {
            clearTimeout(failsafe);
            this.setBusy(false);
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sp-bf-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sp-bf-reviews')) {
    customElements.define(
      'sp-bf-reviews',
      class SpBfReviews extends HTMLElement {
        connectedCallback() {
          if (this.dataset.spReady) return;
          this.dataset.spReady = '1';
          this.button = this.querySelector('[data-sp-more]');
          if (!this.button) return;
          this.onClick = () => {
            const open = this.button.getAttribute('aria-expanded') === 'true';
            this.querySelectorAll('[data-sp-extra]').forEach((card) => {
              card.hidden = open;
            });
            this.button.setAttribute('aria-expanded', open ? 'false' : 'true');
            this.button.textContent = open ? this.dataset.spShowAll : this.dataset.spShowFewer;
            if (open) this.scrollIntoView({ block: 'start', behavior: 'smooth' });
          };
          this.button.addEventListener('click', this.onClick);
        }

        disconnectedCallback() {
          this.button?.removeEventListener('click', this.onClick);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sp-footer"] && !Shopify.designMode) return;
  try {
    
  /*
    Phones: link groups are <details> that start closed (except the first).
    Desktop keeps them open through CSS, so a group toggled shut on a phone,
    then rotated to a tablet, still shows its links.
  */
  (function () {
    const groups = document.querySelectorAll('.sp-footer__group');
    if (!groups.length) return;
    const mq = window.matchMedia('(min-width: 750px)');
    const sync = () => {
      groups.forEach((g, i) => {
        if (mq.matches) {
          g.open = true;
        } else if (!g.dataset.spTouched) {
          g.open = i === 0;
        }
        // the heading is only a toggle on phones; keep it out of the desktop tab order
        const heading = g.querySelector('summary');
        if (heading) heading.tabIndex = mq.matches ? -1 : 0;
      });
    };
    groups.forEach((g) => g.addEventListener('toggle', () => { if (!mq.matches) g.dataset.spTouched = '1'; }));
    sync();
    mq.addEventListener('change', sync);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sp-need-picker"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const root = document.querySelector('[data-sp-need]');
    if (!root || root.dataset.spReady) return;
    root.dataset.spReady = '1';
    const tabs = Array.from(root.querySelectorAll('[data-sp-need-tab]'));
    const panels = Array.from(root.querySelectorAll('[data-sp-need-panel]'));

    // Mark the pill of the world the shopper jumped to; the worlds themselves all stay on the page.
    const select = (tab) => {
      tabs.forEach((t) => { if (t === tab) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current'); });
      return panels.find((p) => '#' + p.id === tab.getAttribute('href')) || null;
    };

    // Bring the chosen panel into view when its top sits below the fold (phones).
    const reveal = (panel) => {
      if (!panel) return;
      const top = panel.getBoundingClientRect().top;
      if (top > window.innerHeight * 0.45 || top < 0) {
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        panel.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      }
    };

    root.addEventListener('click', (event) => {
      const tab = event.target.closest('[data-sp-need-tab]');
      if (tab) { event.preventDefault(); reveal(select(tab)); return; }
      const swatch = event.target.closest('[data-sp-need-swatch]');
      if (!swatch) return;
      const panel = swatch.closest('[data-sp-need-panel]');
      panel.querySelectorAll('[data-sp-need-swatch]').forEach((s) => s.setAttribute('aria-pressed', String(s === swatch)));
      const img = panel.querySelector('.sp-need__image img');
      if (!img) return;
      img.srcset = swatch.dataset.srcset;
      img.src = swatch.dataset.src;
      img.alt = swatch.dataset.alt;
    });

    // Fade the right edge of the tab row while it can still scroll further.
    const list = root.querySelector('[data-sp-need-tabs]');
    const fade = () => { list.classList.toggle('has-more', list.scrollLeft + list.clientWidth < list.scrollWidth - 2); };
    list.addEventListener('scroll', fade, { passive: true });
    window.addEventListener('resize', fade, { passive: true });
    fade();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sp-size-guide"] && !Shopify.designMode) return;
  try {
    
  // Any element with data-sp-size-guide-open opens the dialog; closes on the X,
  // Esc (native) or a tap on the backdrop.
  (function () {
    const dialog = document.querySelector('[data-sp-size-guide]');
    const openers = document.querySelectorAll('[data-sp-size-guide-open]');
    if (!dialog || typeof dialog.showModal !== 'function') return;
    openers.forEach((btn) => {
      btn.hidden = false;
      btn.addEventListener('click', () => dialog.showModal());
    });
    dialog.querySelector('[data-sp-size-guide-close]')?.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (e) => { if (e.target === dialog) dialog.close(); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sp-sticky-atc"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sp-sticky-atc')) {
    customElements.define(
      'sp-sticky-atc',
      class SpStickyAtc extends HTMLElement {
        connectedCallback() {
          if (this.dataset.spReady) return;
          this.dataset.spReady = '1';

          this.button = this.querySelector('[data-sp-sticky-submit]');
          this.priceEl = this.querySelector('[data-sp-sticky-price]');
          this.saveEl = this.querySelector('[data-sp-sticky-save]');
          this.labelEl = this.querySelector('[data-sp-sticky-label]');
          if (!this.button) return;

          // the kit buy box (sp-buy-kits) when the template has one, else Dawn's product form
          this.kits = document.querySelector('product-info sp-buy-kits');
          if (this.kits) {
            this.mainButton = this.kits.querySelector('[data-sp-kits-add]');
            if (!this.mainButton) return;
            this.button.addEventListener('click', () => this.kits.add());
            this.onKits = (event) => this.syncKits(event.detail);
            document.addEventListener('sp-kits:change', this.onKits);
            if (this.kits.state) this.syncKits(this.kits.state);
          } else {
            this.form =
              document.querySelector('product-info form[data-type="add-to-cart-form"]') ||
              document.querySelector('form[data-type="add-to-cart-form"]');
            this.mainButton = this.form ? this.form.querySelector('[type="submit"]') : null;
            if (!this.form || !this.mainButton) return;
            this.button.addEventListener('click', () => {
              if (typeof this.form.requestSubmit === 'function') {
                this.form.requestSubmit(this.mainButton);
              } else {
                this.mainButton.click();
              }
            });
          }

          // Show the bar once the main button has scrolled above the viewport.
          // A scroll check (not IntersectionObserver) so fast or programmatic
          // scrolls that skip the "intersecting" state still update the bar.
          this.ticking = false;
          this.onScroll = () => {
            if (this.ticking) return;
            this.ticking = true;
            window.requestAnimationFrame(() => {
              this.ticking = false;
              this.hidden = this.mainButton.getBoundingClientRect().bottom > 0;
            });
          };
          window.addEventListener('scroll', this.onScroll, { passive: true });
          window.addEventListener('resize', this.onScroll, { passive: true });
          this.onScroll();

          // pubsub.js is deferred and may land after this element connects: keep trying briefly
          this.subscribeTries = 0;
          if (!this.kits) this.trySubscribe();
        }

        // kit buy box: the bar shows the kit total and its saving, and goes disabled with the kit button
        syncKits(state) {
          if (!state) return;
          if (this.priceEl && state.priceText) this.priceEl.textContent = state.priceText;
          if (this.saveEl) {
            this.saveEl.textContent = state.savePercent > 0 ? this.dataset.spSaveLabel.replace('[percent]', state.savePercent) : '';
            this.saveEl.hidden = !(state.savePercent > 0);
          }
          this.button.disabled = !state.available;
          if (this.labelEl) this.labelEl.textContent = state.available ? this.dataset.spAddLabel : this.dataset.spSoldoutLabel;
        }

        trySubscribe() {
          // PUB_SUB_EVENTS is a top-level const in pubsub.js (a global binding, not a window property)
          if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => this.sync(event));
            return;
          }
          if (this.subscribeTries++ < 50) this.subscribeTimer = setTimeout(() => this.trySubscribe(), 200);
        }

        disconnectedCallback() {
          window.removeEventListener('scroll', this.onScroll);
          window.removeEventListener('resize', this.onScroll);
          clearTimeout(this.subscribeTimer);
          if (this.unsubscribe) this.unsubscribe();
          if (this.onKits) document.removeEventListener('sp-kits:change', this.onKits);
        }

        // copy price, Save tag, label and disabled state from the buy box after a variant change
        sync(event) {
          // prefer the freshly fetched section HTML carried by the event, else the live buy box
          const source = event && event.data && event.data.html ? event.data.html : document;
          const price = source.querySelector('product-info .price') || document.querySelector('product-info .price');
          if (price && this.priceEl) {
            const onSale = price.classList.contains('price--on-sale');
            const current = onSale
              ? price.querySelector('.price-item--sale')
              : price.querySelector('.price__regular .price-item--regular');
            if (current) this.priceEl.textContent = current.textContent.trim();
            const badge = price.querySelector('.price__badge-sale');
            if (this.saveEl) {
              const text = onSale && badge ? badge.textContent.trim() : '';
              this.saveEl.textContent = text;
              this.saveEl.hidden = !text;
            }
          }
          // the main button is updated by product-info just before the event fires
          window.requestAnimationFrame(() => {
            this.button.disabled = this.mainButton.hasAttribute('disabled');
            const mainLabel = this.mainButton.querySelector('span');
            if (mainLabel && this.labelEl) this.labelEl.textContent = mainLabel.textContent.trim();
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sp-track-order"] && !Shopify.designMode) return;
  try {
    
  // Send the shopper to the carrier/aggregator page for the number they typed.
  // Without JS the form still submits as a plain GET to the tracker's home page.
  document.querySelectorAll('[data-sp-track]').forEach((form) => {
    form.addEventListener('submit', (event) => {
      const input = form.querySelector('input');
      const number = (input.value || '').trim().replace(/\s+/g, '');
      if (!number) return;
      event.preventDefault();
      window.open(form.dataset.spTrackUrl.replace('{number}', encodeURIComponent(number)), '_blank', 'noopener');
    });
  });

  } catch(e) { console.error(e); }
})();
})();
